import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Resizer.css'
import DraggableArea from '../../common/DraggableArea'

interface Props {
  css?: any
}

interface State {}

@observer
export default class Resizer extends Component<Props, State> {
  sizeBeforeMovement: number;
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return (
      <DraggableArea
        onDragStart={this._onDragStart}
        onDrag={this._onDrag}
        onDragEnd={this._onDragEnd}
        lockCursorTo="ew-resize"
      >
        <div {...classes('container')} />
      </DraggableArea>
    )
  }

  _onDragStart = () => {
    this.sizeBeforeMovement = this.store.general.mapWidth()
  }

  _onDrag = (dx: number) => {
    this.store.general.setMapWidth(this.sizeBeforeMovement - dx)
  }

  _onDragEnd = () => {

  }
}



// WEBPACK FOOTER //
// ./src/housingCorporations/TheMap/Resizer.tsx